<template>
  <div>
    <v-card flat
            tile>
      <v-toolbar color="secondary"
                 dark
                 flat>
        <v-toolbar-title>{{ $t('details') }}</v-toolbar-title>
      </v-toolbar>
      <inventory-transaction-details ref="inventoryTransactionDetails"
                                     v-bind:inventory-transaction="inventoryTransaction" />
    </v-card>
  </div>
</template>

<script>
  import InventoryTransactionDetails from '@/components/inventory-management/InventoryTransactionDetails'

  export default {
    components: {
      InventoryTransactionDetails
    },
    name: 'InventoryTransactionDetailsCard',
    methods: {
      validate() {
        return this.$refs.inventoryTransactionDetails.validate()
      }
    },
    props: {
      inventoryTransaction: Object
    }
  }
</script>

<i18n>
  {
    "de": {
      "details": "Details"
    },
    "en": {
      "details": "Details"
    }
  }
</i18n>